import { useMemo } from "react"

/**
 * Shared base for ContributorsDataGridComponent and DrilldownContributorsDataGridComponent.
 * Extracts fieldExtractors and dataGridRemountKey — identical in both components.
 */
export function useContributorsGridBase({ columns, rows }) {
  const fieldExtractors = useMemo(
    () =>
      columns
        .filter(col => col.valueGetter)
        .map(col => ({ field: col.field, getValue: row => col.valueGetter(undefined, row) })),
    [columns],
  )

  // Remount the DataGrid when the column field set or row id set changes so MUI
  // does not keep focus on a stale rowId/field after trades or factor changes.
  // Sort before joining so a row reorder alone does not force an unnecessary remount.
  const dataGridRemountKey = useMemo(() => {
    const columnSignature = columns.map(col => col.field).slice().sort().join("|")
    const rowSignature = rows.map(row => row.id).slice().sort().join("|")
    return `${columnSignature}::${rowSignature}`
  }, [columns, rows])

  return { fieldExtractors, dataGridRemountKey }
}
